import {TableViewUI} from "./tableviewUI";
import Axios, { AxiosResponse } from "axios";
import { Gamecloud } from "../../../../gamecloud";

export class Tableview extends Gamecloud{
  public constructor(private ui: TableViewUI, public data: any, public formData: any) {
    super();
    this.render(this.data);
    this.ui.onAddButtonClick(this.onAdd.bind(this));

    if (this.ui.isMinecraft()) {
      this.ui.disbaleUuid();
      this.ui.onUsernameChange(this.getUuidByName.bind(this));
      this.ui.onNameChange(this.getUuidByName.bind(this));
    }
  }

  private getUuidByName(value: string) {
    const bodyFormData = new FormData();
    bodyFormData.append('ingame', value);
    Axios.post(window.ajaxPath + '/getUuid', bodyFormData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response: AxiosResponse) => {
      this.ui.updateUuid(response.data.id);
    })
  }

  private onAdd(data) {

    if(!this.data || typeof this.data == 'undefined') {
      this.data = [];
    }

    this.data.push(data);
    this.render(this.data);
  }

  private render(data) {
      if (typeof data !== 'undefined' && data.length) {
      this.ui.render(this.mapToRenderData(data, this.formData), this.afterRender.bind(this));
    } else {
      this.ui.clearTable();
    }
  }

  private afterRender() {
    this.ui.onDeleteButtonClick(this.destory.bind(this));
    if (this.ui.allowedToReorder()) {
      this.ui.sort();
    }
  }

  private destory(id: number) {
    this.data = this.data.filter((item, index) => index !== id);
    this.render(this.data);
  }

  private mapToRenderData(data, formData) {
    const name = this.ui.getTableKey();
    if (data && data.length > 0) {
      const mappedData = data.map((dataItem) => {
        if(typeof formData.sections[name] !== 'undefined') {
          const vars = formData.sections[name].variables;
          vars.map((varData) => {
            if (typeof varData.choices !== 'undefined') {
              const choices = varData.choices;
              if (typeof choices !== 'undefined') {
                for (const key in dataItem) {
                  if (dataItem.hasOwnProperty(key) && typeof key !== 'undefined') {
                    const element = dataItem[key];
                    if (varData.name === key) {
                      let tableValue = false;
                      tableValue = choices.filter((item) => {
                        if (item[0] === Number(element).toString()) {
                          return item;
                        }
                      });

                      if (tableValue) {
                        if (typeof tableValue[0] !== 'undefined') {
                          if (typeof tableValue[0][1] !== 'undefined') {
                            dataItem = { ...dataItem, [key]: { hiddenValue: element, tableValue: tableValue[0][1]}};
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          });
        }

        return dataItem;
      });

      return mappedData;
    }
  }
}
